<div class="pme-container">
  <div class="display-utils-col display-utils-gt-sm-row display-utils-center">
    <div *ngIf="this.heroData && this.heroData.title !== 'Cancelamento de plano'" class="pme-col display-utils-gt-sm-flex-50">
      <pme-hero *ngIf="this.showHero" type="{{this.heroData.type}}" title="{{this.heroData.title}}"
        showButton="{{this.heroData.showButton}}" buttonName="{{this.heroData.buttonName}}"
        redirectURL="{{this.heroData.redirectURL}}">
        <p *ngFor="let content of this.heroData.contents">{{content}}</p>
      </pme-hero>
    </div>
  </div>

  <div *ngIf="bankPixContract; else creditCardContract">
    <div class="pme-row display-utils-col display-utils-gt-sm-row display-utils-center display-utils-gap-0 display-utils-gt-sm-gap-120">
      <div class="display-utils-col" style="padding-bottom: 20px;">
        <div class="title display-utils-col display-utils-start-left display-utils-flex-auto">
          <h1>Cancelamento de plano</h1>
          <p>
            Para solicitar o cancelamento, por favor,
            <b>entre em contato com nossa central de atendimento pelo WhatsApp.</b>
          </p>
        </div>
        <div class="display-utils-col display-utils-gt-sm-row display-utils-between-stretch display-utils-gap-20">
          <a href="https://wa.me/551130037372" class="wppLink display-utils-flex-100 display-utils-gt-sm-flex-35 display-utils-gt-lg-flex-30"
            style="width: 100%; display: flex; align-items: center;">
            <mat-card class="card">
              <mat-card-content>
                <div class="cardContent margin-none display-utils-row display-utils-start-center">
                  <img src="/assets/images/ic_outline-whatsapp.svg" alt="WhatsApp Icon">
                  <div class="display-utils-row display-utils-gt-sm-col display-utils-center-flexstart display-utils-lt-md-start-center display-utils-lt-md-gap-20">
                    <p class="title">WhatsApp</p>
                    <a href="https://wa.me/551130037372" class="wppLink">
                      <p><b>(11) 3003-7372</b></p>
                    </a>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </a>
          <a href="https://ajuda.pmedigital.serasaexperian.com.br/hc/pt-br/requests/new?ticket&_gl=1zdk106_gcl_awR0NMLjE3Mjk4NzQ3ODEuRUFJYUlRb2JDaE1JcnJMazJ2MnBpUU1WOVJhdEJoMUFjeWtlRUFBWUFTQUFFZ0pUX1BEX0J3RQ.._gcl_auOTkxNjg0NzUwLjE3Mjk4NzQ3Nzg._gaNzYxMjYzNzUuMTcyOTg3NDc4MA.._ga_0CR6WR71VQ*MTcyOTg3NDc4MC4xLjAuMTcyOTg3NDc4MC42MC4wLjA." style="width: 100%;" class="wppLink display-utils-flex-100 display-utils-gt-sm-flex-65 display-utils-gt-lg-flex-70">
            <mat-card class="card">
              <mat-card-content>
                <div class="cardContent margin-none display-utils-row display-utils-start-center">
                  <img src="/assets/images/help-basic.svg" alt="Help Icon">
                  <div class="display-utils-col display-utils-left display-utils-gap-4">
                    <p class="title">Central de atendimento</p>
                    <p>Ficou com dúvida? Acesse nossa <b>Central de Ajuda.</b></p>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </a>
        </div>
      </div>

      <div class="display-utils-gt-sm-flex-30 display-utils-flex-100">
        <aside>
          <div *ngIf="this.showForm">
            <pme-product-choice style="width: 100%;" [cardTitle]="'Plano atual'" [changeText]="" [changeLink]=""
              [productName]="planName" [totalValue]="value" [description]="" [productNameBold]="true">
              <hr class="divider">
              <div class="pme-product-choice-item mat-h3 display-utils-col display-utils-gap-1rem">
                <div class="display-utils-row display-utils-between-center">
                  <div class="color-blue ">Início da assinatura</div>
                  <div class="pme-text-right color-blue ">{{startDate}}</div>
                </div>
                <div class="display-utils-row display-utils-between-center">
                  <div><b>Término da assinatura</b></div>
                  <div class="pme-text-right"><b>{{endDate}}</b></div>
                </div>
              </div>

              <div class="back-button">
                <a href="{{this.redirectUrl}}">Voltar</a>
              </div>
            </pme-product-choice>
          </div>
        </aside>
      </div>
    </div>
  </div>

  <ng-template #creditCardContract>

    <div class="pme-row display-utils-col display-utils-gt-sm-row display-utils-center display-utils-gap-0 display-utils-gt-sm-gap-120">
      <div class="pme-col display-utils-gt-sm-flex-50 display-utils-hide-lt-md">
        <aside>

          <!-- New product choice -->
          <!-- Melhoria pendente para simplificar o envio da lista de itens -->

          <div *ngIf="this.showForm">
            <pme-product-choice [cardTitle]="'Plano atual'" [changeText]="" [changeLink]="" [productName]="planName"
              [totalValue]="value" [description]="">

              <div class="pme-product-choice-item mat-h3 display-utils-col display-utils-gap-1rem">
                <div class="display-utils-row display-utils-between-center">
                  <div>Início da assinatura</div>
                  <div class="pme-text-right">{{startDate}}</div>
                </div>
                <div class="display-utils-row display-utils-between-center">
                  <div><b>Término da assinatura</b></div>
                  <div class="pme-text-right"><b>{{endDate}}</b></div>
                </div>
              </div>
            </pme-product-choice>

            <div class="back-button display-utils-only-gt-sm">
              <mat-icon (click)="paymentFormSubmitting ? null : return()">arrow_back</mat-icon>
              <a href="{{this.redirectUrl}}">Voltar</a>
            </div>
          </div>

          <!-- Old plan choice -->

          <!-- <mat-card class="pme-card-plan-choice">
          <mat-card-content>
            <div class="pme-card-content-plan-choice display-utils-row display-utils-between">
              <div class="mat-h3">
                <b>{{planName}}</b>
              </div>
              <div class="mat-h3 pme-text-right">{{value | currency: 'R$'}}</div>
            </div>

            <ul class="pme-cart-list">
              <li><b>Início da assinatura: </b>{{startDate}}</li>
              <li><b>Término da assinatura: </b>{{endDate}}</li>
            </ul>
          </mat-card-content>
        </mat-card> -->

        </aside>
      </div>

      <div class="pme-col display-utils-gt-sm-flex-50">
        <main>

          <div *ngIf="!this.showHero || this.showForm">

            <form *ngIf="this.showForm" [formGroup]="this.cancellationForm" (ngSubmit)="onSubmit()">
              <div>
                <div>
                  <span class="pme-heroData-title">{{this.heroData.title}}</span>
                  <p class="pme-dark-secondary-text">{{this.heroData.contents}}</p>
                </div>

                <div class="display-utils-hide-gt-sm">
                  <pme-mobile-dropdown>
                    <p title class="color-blue-buy">Resumo do cancelamento</p>
                    <div content>
                      <aside>
                        <pme-product-choice [cardTitle]="'Plano atual'" [changeText]="" [changeLink]=""
                          [productName]="planName" [totalValue]="value" [description]="">

                          <div class="pme-product-choice-item mat-h3 display-utils-col display-utils-gap-1rem">
                            <div class="display-utils-row display-utils-between-center">
                              <div>Início da assinatura</div>
                              <div class="pme-text-right">{{startDate}}</div>
                            </div>
                            <div class="display-utils-row display-utils-between-center">
                              <div><b>Término da assinatura</b></div>
                              <div class="pme-text-right"><b>{{endDate}}</b></div>
                            </div>
                          </div>
                        </pme-product-choice>
                      </aside>
                    </div>
                  </pme-mobile-dropdown>
                </div>

                <mat-form-field class="custom-mat-field" appearance="outline">
                  <mat-label>Motivo do cancelamento</mat-label>
                  <mat-select matNativeControl [(ngModel)]="selectedOption" [ngModelOptions]="{standalone: true}"
                    formControlName="reasonForCancellation" id="reasonForCancellation" name="reasonForCancellation"
                    required>
                    <mat-option *ngFor="let reasonForCancellation of reasonsForCancellation"
                      [value]="reasonForCancellation.identifier">
                      {{reasonForCancellation.reason}}
                    </mat-option>
                  </mat-select>
                  <mat-error>{{getBankFormErrors().reasonForCancellation}}</mat-error>
                </mat-form-field>

                <mat-form-field class="custom-mat-field" appearance="outline" floatLabel="always">
                  <mat-label class="message-title">Mensagem</mat-label>
                  <textarea rows="8" matNativeControl [(ngModel)]="this.message" matInput type="text"
                    formControlName="message" class="mat-textarea" id="message" name="message"
                    placeholder="Deixe o seu comentário, crítica ou sugestão. Sua opinião é muito importante! :)"></textarea>
                  <mat-error>{{getBankFormErrors().message}}</mat-error>
                </mat-form-field>
              </div>

              <div *ngIf="this.showBankForm">
                <div>
                  <span class="pme-heroData-title">Dados bancários</span>
                  <p class="pme-dark-secondary-text">Informe os dados de sua conta para devolução integral do valor
                    pago.</p>
                </div>

                <mat-form-field class="custom-mat-field" appearance="outline">
                  <mat-label>Banco</mat-label>
                  <mat-select matNativeControl #bank [(ngModel)]="this.customerBankData.bankString"
                    formControlName="bank" id="bank" name="bank" required>
                    <mat-option *ngFor="let bank of this.banks" [value]="bank.formattedName">
                      {{bank.formattedName}}
                    </mat-option>
                  </mat-select>
                  <mat-error>{{getBankFormErrors().bank}}</mat-error>
                </mat-form-field>

                <div class="pme-radio-group">
                  <label><b>Tipo de conta</b></label>
                  <mat-radio-group formControlName="accountType" #accountType="matRadioGroup"
                    [(ngModel)]="this.customerBankData.accountType" id="accountType" name="accountType">
                    <div class="pme-radio-button">
                      <mat-radio-button value="Conta corrente">Conta corrente</mat-radio-button>
                      <mat-radio-button value="Conta poupança">Conta poupança</mat-radio-button>
                    </div>
                  </mat-radio-group>
                </div>

                <div class="display-utils-row display-utils-gap-8 display-utils-gt-xs-gap-12">
                  <div class="display-utils-flex-50">
                    <mat-form-field class="custom-mat-field" appearance="outline">
                      <mat-label>Agência</mat-label>
                      <input matInput type="number" pattern="[0-9]*" inputmode="numeric"
                        [(ngModel)]="this.customerBankData.agency" placeholder="0000" formControlName="agency"
                        id="agency" name="agency" required>
                      <mat-error>{{getBankFormErrors().agency}}</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="display-utils-flex-50">
                    <mat-form-field class="custom-mat-field" appearance="outline">
                      <mat-label>Conta corrente</mat-label>
                      <input matInput type="number" pattern="[0-9]*" inputmode="numeric"
                        [(ngModel)]="this.customerBankData.account" placeholder="0000000-0" formControlName="account"
                        id="account" name="account" required>
                      <mat-error>{{getBankFormErrors().account}}</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <mat-form-field class="custom-mat-field" appearance="outline">
                  <mat-label>Nome do favorecido</mat-label>
                  <input matInput type="text" placeholder="Nome completo" [(ngModel)]="this.customerBankData.name"
                    formControlName="name" id="name" name="name" required>
                  <mat-error>{{getBankFormErrors().name}}</mat-error>
                </mat-form-field>

                <mat-form-field class="custom-mat-field" appearance="outline">
                  <mat-label>CPF/CNPJ</mat-label>
                  <input matInput formControlName="cpfCnpj" id="cpfCnpj" [(ngModel)]="this.customerBankData.cpfCnpj"
                    name="cpfCnpj" [mask]="cpfCnpjMask" required>
                  <mat-error>{{getBankFormErrors().cpfCnpj}}</mat-error>
                </mat-form-field>

              </div>

              <pme-alert type="error" title="Erro" *ngIf="this.cancelFormErrors && this.cancelFormErrors.length">
                <div *ngFor="let error of this.cancelFormErrors">{{error}}</div>
              </pme-alert>

              <div class="pme-fixed-button display-utils-row display-utils-center-center display-utils-gap-20">
                <!-- <a href="{{this.redirectUrl}}">Voltar</a> -->

                <button mat-flat-button type="submit" class="pme-btn-lg cancel-button"
                  [disabled]="submitting || !this.cancellationForm.valid">
                  <div class="display-utils-row display-utils-center-center display-utils-gap-8">
                    <mat-spinner *ngIf="submitting" diameter="20" aria-label="Carregando"></mat-spinner>
                    <div style="text-transform: none;">Cancelar plano</div>
                  </div>
                </button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </div>
  </ng-template>
</div>